import React from "react";
import { Helmet } from "react-helmet";


export const PaymentSeo = ({ title, canonicalLink, description, img }: {title: string, canonicalLink?: string, description?: string, img: string}) => (
  <Helmet>
    <meta charSet="utf-8" />
    {
      title && (<title>{title}</title>)
    }
    <link rel="icon" href={img} type="image/x-icon" />
    <link rel="shortcut icon" href={img} type="image/x-icon"></link>
    {
      canonicalLink && (<link rel="canonical" href={canonicalLink} />)
    }
    {
      description && (<meta name="description" content={description} />)
    }

  </Helmet>
);
